var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460 416L460 444",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.5,
    cy: 411.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M455.987 411.19C455.987 407.283 459.288 404.117 463.358 404.117C463.943 404.117 464.511 404.184 465.056 404.308C463.742 403.48 462.187 403 460.519 403C455.814 403 452 406.806 452 411.5C452 416.194 455.814 420 460.519 420C462.814 420 464.895 419.093 466.427 417.62C465.492 418.032 464.454 418.263 463.358 418.263C459.288 418.263 455.987 415.096 455.987 411.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M469.402 410.6L469.37 408.146L467.535 409.719L465.304 409.056L466.112 411.337L464.765 413.381L467.1 413.218L468.499 415.144L469.133 412.763L471.345 411.909L469.402 410.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.f7db5d45ce7e471f648fc70e0b5e57d9.svg";
export { ForwardRef as ReactComponent };